/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/attachment'
export default icon
